<template>
  <div>
    <v-dialog v-model="commentDialogBox" width="800">
      <template #activator="{ on: dialog }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn
              flat
              icon
              v-on="{ ...tooltip, ...dialog }"
              @click="getUserTask"
            >
              <v-icon>comment</v-icon>
            </v-btn>
          </template>
          <span>Comments</span>
        </v-tooltip>
      </template>
      <v-card class="beez-card" v-if="selectedId === taskHexId">
        <v-toolbar class="beez-bold body-2" dense card>
          Comments
          <v-spacer />
          <v-btn icon flat @click="commentDialogBox = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
          <v-layout row wrap>
            <v-flex xs12 sm12 md3 lg3>
              <v-dialog v-model="commentDialog" persistent max-width="600px">
                <template #activator="{ on: dialog}">
                  <v-btn
                    :disabled="readOnly"
                    v-on="{ ...dialog }"
                    :outline="$vuetify.dark"
                    v-if="can('TASK_CLAIM_COMMENT')"
                    :loading="commentLoader"
                    class="text-capitalize"
                  >
                    Add New Comment
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="body-1">Add New comment</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-textarea
                            flat
                            name="input-description-1"
                            box
                            label="Comments*"
                            auto-grow
                            required
                            rows="1"
                            v-model="newCommentMessage"
                            placeholder="Please enter your comments"
                          />
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      :outline="$vuetify.dark"
                      class="text-capitalize"
                      @click="commentDialog = false"
                      >Close
                    </v-btn>
                    <v-btn
                      :outline="$vuetify.dark"
                      :disabled="readOnly"
                      :class="
                        $vuetify.dark
                          ? 'secondary text-capitalize'
                          : 'primary text-capitalize'
                      "
                      flat
                      @click="addComment"
                      >Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12>
              <v-progress-linear
                indeterminate
                v-show="commentLoader"
              ></v-progress-linear>
              <v-flex class="beez-padding">
                <v-layout
                  row
                  fill-height
                  v-if="comments.length > 0"
                  class="py-0"
                >
                  <v-timeline dense clipped style="width: 100%">
                    <v-timeline-item
                      v-for="(comment, i) in taskComments"
                      :key="i"
                      color="secondary"
                      fill-dot
                      small
                    >
                      <template>
                        <v-layout row wrap>
                          <v-flex xs2>
                            <strong class="pa-2">{{
                              comment.timeLocal
                            }}</strong>
                          </v-flex>
                          <v-flex xs10>
                            <v-card style="border-radius: 10px">
                              <v-card-text>
                                "{{ comment.message }}"
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <b> - {{ comment.userId }} </b>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-timeline-item>
                  </v-timeline>
                </v-layout>
                <v-layout v-else>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      color="success"
                      icon="info"
                      style="border-radius: 5px;"
                    >
                      No comments found!
                    </v-alert>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TaskComments',

  computed: {
    ...mapState({
      comments: state => state.tasks.comments
    }),
    ...mapGetters({
      can: 'can'
    }),
    taskComments() {
      return this.comments || this.userTask.taskComments
    }
  },

  data() {
    return {
      selectedId: null,
      taskId: '',
      userTask: {},
      readOnly: false,
      commentLoader: false,
      commentDialogBox: false,
      commentDialog: false,
      newCommentMessage: ''
    }
  },

  props: {
    taskHexId: String
  },

  methods: {
    resetComments() {
      this.$store.dispatch('resetTaskComments')
    },
    async getUserTask() {
      this.commentLoader = true
      this.resetComments()
      try {
        if (this.taskHexId) {
          this.selectedId = this.taskHexId
          this.readOnly = true
          this.userTask = await this.$store.dispatch(
            'getUserTaskDetails',
            this.taskHexId
          )
          if (this.userTask) {
            this.taskId = this.userTask.taskId
            if (
              this.userTask.status === 'complete' ||
              this.userTask.status === 'delete'
            ) {
              this.readOnly = true
            } else {
              this.readOnly = false
            }
            await this.getCommentHistory()
          }
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to get User Task Comments!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.commentLoader = false
    },
    async getCommentHistory() {
      this.commentLoader = true
      try {
        if (this.taskId && !this.readOnly) {
          this.readOnly = false
          await this.$store.dispatch('fetchTaskComments', this.taskId)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to get User Task Comments!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.commentLoader = false
    },
    async addComment() {
      let body = {}
      body.message = this.newCommentMessage
      await this.$store.dispatch('addTaskComment', {
        id: this.taskId,
        body: body
      })
      await this.getCommentHistory()
      this.newCommentMessage = ''
      this.commentDialog = false
      await this.$store.dispatch('directNotification', {
        timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
        message: 'Comment has been Added',
        description: 'User Task comment added Successfully',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped></style>
